const state = {
  user: null,
}

const mutations = {
  __reset (state) {
    state.user = null
  },
  setUser (state, user) {
    state.user = user
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
